import axios from '../../bootstrap';

/**
 * @param {any} objData
 */
export function axiosSaveImage(objData) {
    return axios.post('/api/admin/images/saveimage', objData);
}

/**
 * @param {string} objData
 */
export function axiosDeleteImage(objData) {
    return axios.post('/api/admin/images/deleteimage', objData);
}

export function axiosRebuildMyImagesJSON() {
    return axios.get('/api/admin/images/rebuildmyimagesjson');
}
